// Shared door-card photography (İşveren = corporate architecture,
// Aday = professional portrait), used by AnaMenu and HizmetlerimPage.
// TODO: replace with local assets (public/images/door-isveren.jpg,
// public/images/door-aday.jpg) when final photography is ready.
const DOORS = [
  { img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1400&q=72&fm=jpg" },
  { img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=1200&q=72&fm=jpg", pos: "center 18%" },
];

export default DOORS;
